import { render, staticRenderFns } from "./CompTemplateDocDetail.vue?vue&type=template&id=6a723f0b&scoped=true&"
import script from "./CompTemplateDocDetail.vue?vue&type=script&lang=js&"
export * from "./CompTemplateDocDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a723f0b",
  null
  
)

export default component.exports